import { render, staticRenderFns } from "./EmployeeFormSubmissionCommentListItem.vue?vue&type=template&id=08e80289&"
import script from "./EmployeeFormSubmissionCommentListItem.vue?vue&type=script&lang=ts&"
export * from "./EmployeeFormSubmissionCommentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports